import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useTranslation } from "react-i18next";
import "../../../Localization/i18n";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {},
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));
export default function VendorQuestios(props) {
  const { t } = useTranslation();

  return (
    <>
      <TableContainer component={Paper} hidden={props?.questions?.length==0}>
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell
                align="left"
                className="text-muted"
                hidden={props?.questions?.length==0}
              >
                <span
                  className="text-muted"
                  style={{ color: "#3E4A62", fontWeight: "bolder", fontSize: "larger" }}>{t('VendorDetails.label3')}</span>
              </StyledTableCell>
              <StyledTableCell>&nbsp;</StyledTableCell>
              <StyledTableCell>&nbsp;</StyledTableCell>
            </TableRow>
          </TableHead>

          {props?.questions?.map((r) => (
            <TableRow key={r.key}>
              <StyledTableCell sx={{ width: "500px" }}>
                {r?.questionName}
              </StyledTableCell>

              <StyledTableCell align="left" className="text-muted">
                {r?.answers[0]}
              </StyledTableCell>
              <StyledTableCell>&nbsp;</StyledTableCell>
            </TableRow>
          ))}
        </Table>
      </TableContainer>
    </>
  )
}
